import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Product",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.31 7.47 16.71.2c-.21-.12-.46-.2-.73-.2s-.52.07-.73.2-12.6 7.27-12.6 7.27c-.43.26-.71.72-.71 1.25v14.55c0 .54.29 1 .72 1.26s12.6 7.28 12.6 7.28c.21.12.46.2.73.2s.52-.07.73-.2 12.6-7.27 12.6-7.27c.44-.26.73-.73.73-1.26V8.74c0-.54-.3-1.01-.74-1.26ZM15.99 3.13l9.7 5.59-3.36 1.94-9.5-5.7L16 3.13Zm-1.45 24.89-9.7-5.59V11.25l3.49 2.01 6.21 3.59v11.18Zm1.45-13.7-9.7-5.59 3.64-2.1 9.51 5.7-3.45 2Zm11.14 8.11-9.7 5.59V16.84l3.38-1.94v3.97a1.451 1.451 0 0 0 2.9 0v-5.66l3.38-1.94.02 11.16Z"
    })
  }));
};